import { render, staticRenderFns } from "./AdminCellDialogText.vue?vue&type=template&id=661ac5c2&"
import script from "./AdminCellDialogText.vue?vue&type=script&lang=js&"
export * from "./AdminCellDialogText.vue?vue&type=script&lang=js&"
import style0 from "./AdminCellDialogText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VEditDialog,VTextField})
